import { CARRIER_ACCESS_ROLE_KEEP_CURRENT } from "lib/viagens-controle-permissions";
import { Combine } from "utils/TypesHelper";
import { z } from "zod";



const carrierAccessRoleSchema = z.object({
    accessRoleName: z.preprocess(
        (value) =>
            value === '' || value === CARRIER_ACCESS_ROLE_KEEP_CURRENT
                ? undefined
                : value,
        z.enum(['carrierMember', 'carrierMemberStayValidation']).optional()
    ),
})

const carrierMemberSchema = z.object({
    carrierId: z.array(
        z.object({
            value: z.any({ required_error: "Transportadora do usuário é obrigatória" }),
            label: z.string()
        })
    ),
})
const warehouseMemberSchema = z.object({
    companyId: z.array(
        z.object({
            value: z.any({ required_error: "Armazém do usuário é obrigatório" }),
            label: z.string()
        })
    ),
})
const clientMemberSchema = z.object({
    clientId: z.array(
        z.object({
            value: z.any({ required_error: "Cliente do usuário é obrigatório" }),
            label: z.string()
        })
    ),
})

const userSchema = z.object({
    user: z.object({
        name: z.string({ required_error: "Nome do usuário é obrigatório" }),
        email: z
            .string({ required_error: "Email do usuário é obrigatório" })
            .email("Email inválido"),
        password: z.string({ required_error: "Senha do usuário é obrigatório" }),
    })
})

const updateUserSchema = z.object({
    user: z.object({
        name: z.string({ required_error: "Nome do usuário é obrigatório" }),
        email: z
            .string({ required_error: "Email do usuário é obrigatório" })
            .email("Email inválido")
    })
})

export const updateFormSchema = z.discriminatedUnion('type', [
    updateUserSchema.extend({
        type: z.literal("carrierMember"),
    }).merge(carrierMemberSchema).merge(carrierAccessRoleSchema),
    updateUserSchema.extend({
        type: z.literal("warehouseMember"),
    }).merge(warehouseMemberSchema),
    updateUserSchema.extend({
        type: z.literal("clientMember"),
    }).merge(clientMemberSchema),
    updateUserSchema.extend({
        type: z.literal("admin"),
    }),
    updateUserSchema.extend({
        type: z.literal("planner"),
        material_id: z.string().optional(),
    }),
    updateUserSchema.extend({
        type: z.literal("consultMember"),
    }),
], {
    errorMap: (issue, ctx) => {
        if (issue.code === 'invalid_union_discriminator')
            return { message: `Selecione o valor.` }
        return { message: ctx.defaultError }
    },
})


export const formSchema = z.discriminatedUnion('type', [
    userSchema.extend({
        type: z.literal("carrierMember"),
    }).merge(carrierMemberSchema).merge(carrierAccessRoleSchema),
    userSchema.extend({
        type: z.literal("warehouseMember"),
    }).merge(warehouseMemberSchema),
    userSchema.extend({
        type: z.literal("clientMember"),
    }).merge(clientMemberSchema),
    userSchema.extend({
        type: z.literal("admin"),
    }),
    userSchema.extend({
        type: z.literal("planner"),
        material_id: z.string().optional(),
    }),
    userSchema.extend({
        type: z.literal("consultMember"),
    }),
], {
    errorMap: (issue, ctx) => {
        if (issue.code === 'invalid_union_discriminator')
            return { message: `Selecione o tipo de usuário.` }
        return { message: ctx.defaultError }
    },
})


export type FormType = Combine<z.infer<typeof formSchema>>
export type UpdateFormType = Combine<z.infer<typeof updateFormSchema>>